import { render, staticRenderFns } from "./TemplateType.vue?vue&type=template&id=3a72fae8&"
import script from "./TemplateType.vue?vue&type=script&lang=js&"
export * from "./TemplateType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TemplateType.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports